import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { quantityInventoryOfWasteWarehouseRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.STORE];

const quantityInventoryOfWasteWarehouseRouteMetadata: IRouteMetadataObj<
  typeof quantityInventoryOfWasteWarehouseRoutesObj
> = {
  list: {
    title: "warehouseManagement.index.title",
    description: "empty",
    lazy: () =>
      import("@pages/warehouseManagement/quantityInventoryOfWasteWarehouse/table/page"),
    mode: "index",
    type: "main",
    icon: "Building2Line",
    breadcrumbs: [],
    permission,
  },
  viewItemInventory: {
    title: "warehouseManagement.viewItemInventory.title",
    description: "empty",
    lazy: () =>
      import("src/pages/warehouseManagement/viewItemInventory/table/page"),
    mode: "view",
    type: "inner",
    icon: "NumbersLine",
    breadcrumbs: [],
    permission,
  },

  warehouseExit: {
    title: "warehouseManagement.warehouseExit.title",
    description: "empty",
    lazy: () => import("@pages/warehouseManagement/warehouseExit/form/page"),
    mode: "create",
    type: "inner",
    icon: "SubtractLine",
    breadcrumbs: [],
    permission,
  },
  returnFromScrapWarehouse: {
    title: "warehouseManagement.returnFromScrapWarehouse.title",
    description: "empty",
    lazy: () =>
      import("@pages/warehouseManagement/returnFromScrapWarehouse/form/page"),
    mode: "create",
    type: "inner",
    icon: "RestartLine",
    breadcrumbs: [],
    permission,
  },
};

export const quantityInventoryOfWasteWarehouseRoutes = createRoute<
  typeof quantityInventoryOfWasteWarehouseRoutesObj
>(
  quantityInventoryOfWasteWarehouseRoutesObj,
  quantityInventoryOfWasteWarehouseRouteMetadata,
);
